/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeRequestContactRequest
 */
export interface ChangeRequestContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestContactRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestContactRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestContactRequest
     */
    website?: string;
}

/**
 * Check if a given object implements the ChangeRequestContactRequest interface.
 */
export function instanceOfChangeRequestContactRequest(value: object): value is ChangeRequestContactRequest {
    return true;
}

export function ChangeRequestContactRequestFromJSON(json: any): ChangeRequestContactRequest {
    return ChangeRequestContactRequestFromJSONTyped(json, false);
}

export function ChangeRequestContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'website': json['website'] == null ? undefined : json['website'],
    };
}

export function ChangeRequestContactRequestToJSON(json: any): ChangeRequestContactRequest {
    return ChangeRequestContactRequestToJSONTyped(json, false);
}

export function ChangeRequestContactRequestToJSONTyped(value?: ChangeRequestContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'website': value['website'],
    };
}

